import React from 'react';
import { useSetRecoilState } from 'recoil';
import { gameProgressState } from '../state';


const Home = () => {
  const setGameProgress = useSetRecoilState(gameProgressState);
  return (
    <div>
    <div className="start-frame">

      <div className="start-title">
      <img src="img/title.png" className="start-titleimg" alt='start-title'/>
      <br />
      <img src="img/subtitle.png" className="start-subtitleimg" alt='start-subtitle'/><br />
      <button onClick={() => setGameProgress('intro')} className="start-botton">START</button>
      </div>
      <img src="img/start-tlimg.png" className="start-tlimg" alt='background' />
    </div>
    <div className="start-alert">建議使用Internet Explorer以外的瀏覽器，以達到最佳瀏覽效果。</div>
  </div>
  );
};

export {
  Home
};
